import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateCancelShipmentReasonEntity } from '../../domain/entities/CreateUpdateCancelShipmentReasonEntity'
import { RoleType } from '@/features/role/domain/enums/RoleType'
import type { PostCancelShipmentReasonRequestAdmin } from '@/backend/market'

export class CreateUpdateCancelShipmentReasonModel extends CreateUpdateCancelShipmentReasonEntity {
  role = RoleType.CLIENT
  translations = []
  constructor(dataDto: CreateUpdateCancelShipmentReasonEntity) {
    super()
    mapEntityProperties<PostCancelShipmentReasonRequestAdmin>(this, dataDto)
  }
}
